module.exports = __webpack_public_path__ + "static/media/lora_indoor_modbus_en.35310444.md";